export default {
    planosManutencao: [],
    planoManutencao: {},
    planosEquipamento: [],
    ultimaAtualizacaoPlanoManutencao: Date
}